module.exports = __webpack_public_path__ + "media/images/balance-prosperity-greenblue-2394e7e881f9bad20a44e7f592c1d75f.png";